import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { Tools } from '@service/tools';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ButtonDirective} from "primeng/button";
import {DialogModule} from "primeng/dialog";

@Component({
    selector: 'countdocs',
    standalone: true,
    templateUrl: 'countdocs.component.html',
    styleUrls: ['countdocs.component.scss'],
    imports: [
        ButtonDirective,
        TranslateModule,
        DialogModule
    ],

})
export class CountDocsComponent implements OnInit, OnChanges {
    @Input()
    public visible: boolean = false;

    @Input()
    public anbdoc: number;
    
    @Output()
    public onAnbdocUpdate: EventEmitter<string> = new EventEmitter<string>();

    public message: string;
    public showExecuteButton: boolean = false;

    constructor(
        protected _messageService: MessagesService,
        public tools: Tools,
        public translate: TranslateService,
    ) {}

    public ngOnInit() {
    }

    public ngOnChanges() {
        this.updateMessage();
    }

    public onShow() {
        this.updateMessage();
    }

    private updateMessage() {
        this.message = this.tools.getMsgCount(this.anbdoc, true);
        this.showExecuteButton = this.anbdoc > 0;
    }

    public closeDialog() {
        this.onAnbdocUpdate.emit('close');
    }

    public execute() {
        this.onAnbdocUpdate.emit('execute');
    }
}
